import React from "react";
import FSHomeTurniri from "./FSHomeTurniri";
// import FSHomeStats from "./FSHomeStats";
import FSHomeJoin from "./FSHomeJoin";
import HomeFooter from "../HomePage/HomeFooter";

import HomeSponsors from "../HomePage/HomeSponsors";
import FSHomeLive from "./FSHomeLive";
import FSNavigation from "./FSNavigation";
import FSHomeFinished from "./FSHomeFinished";
import FSHomeFAQ from "./FSHomeFAQ";
import FSHomeReviews from "./FSHomeReviews";

const FSHome = () => {
  return (
    <>
      <FSNavigation />
      <div className="scorify-app">
        <main className="scorify-main">
          <FSHomeLive />
          <FSHomeTurniri />
          <FSHomeFinished />
          {/*           <FSHomeStats /> */}
          <FSHomeJoin />
          <FSHomeReviews />
          <FSHomeFAQ />
        </main>
      </div>
      <HomeSponsors />
      <HomeFooter />
    </>
  );
};

export default FSHome;
